// extracted by mini-css-extract-plugin
export default {"img":"AdditionalLink_img__EolWm","additionalLink":"AdditionalLink_additionalLink__HcEj7","title":"AdditionalLink_title__vTQX8"};